<lcs-loading-overlay [show]="callState | lcsCallState : 'loading'">
  <div mat-dialog-title class="dialog-header">
    <h3 class="dialog-title">Add Phone</h3>
    <button type="button" mat-icon-button tabindex="-1" (click)="onCloseClick()"><mat-icon>close</mat-icon></button>
  </div>
  <form [formGroup]="form" (ngSubmit)="onCreate()">
    <mat-dialog-content>
      <mat-form-field>
        <mat-label>Account</mat-label>
        <input
          autocomplete="off"
          type="text"
          [lcsSingleSelect]="accountSel"
          ndtAccountSelect
          formControlName="account"
          id="b796706c-939c-482d-82a4-d5dfea7db15b"
          #account
          />
          <ndt-account-select #accountSel></ndt-account-select>
        </mat-form-field>
        <mat-form-field>
          <mat-label>Phone Model</mat-label>
          <input
            autocomplete="off"
            type="text"
            formControlName="deviceTypeId"
            id="5eb0e10c-48df-4b98-a52e-47f4852e6f26"
            lcsStaticSelect
            [lcsSingleSelect]="deviceTypeSelect"
            [lcsStaticSelectValue]="form.get('deviceTypeId')?.value"
            required
            (search)="deviceSearch($event)"
            (reset)="deviceSearchReset()"
            />
            @if (form.get('deviceTypeId')?.hasError('required')) {
              <mat-error> Device Type is Required. </mat-error>
            }
            <lcs-static-select #deviceTypeSelect>
              @for (deviceTypes of deviceTypes; track deviceTypes) {
                <lcs-option [value]="deviceTypes">
                  {{ deviceTypes }}
                </lcs-option>
              }
            </lcs-static-select>
          </mat-form-field>
          <mat-form-field class="flex-full">
            <mat-label>Mac Address</mat-label>
            <input
              matInput
              autocomplete="off"
              type="text"
              formControlName="macAddress"
              id="fb638e93-3e69-4a00-b083-c5203e42fb77"
              />
              @if (form.get('macAddress')?.hasError('required')) {
                <mat-error> Mac Address is Required. </mat-error>
              }
              @if (form.get('macAddress')?.hasError('pattern')) {
                <mat-error>
                  Incorrect Mac Address Format, must be 12 characters containing [a-f,A-F,0-9]
                </mat-error>
              }
            </mat-form-field>
          </mat-dialog-content>
          <mat-dialog-actions>
            <button type="button" title="submitAndAddAnother" (click)="onCreateAndAddAnother()" mat-stroked-button
              >Save and Add Another</button
              >
              <button type="submit" title="Create" id="c46ac2a0-5414-44d0-9b08-66f025390b72" mat-raised-button color="primary">Save</button>
            </mat-dialog-actions>
          </form>
        </lcs-loading-overlay>
